import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import ChatConversationList from './ChatConversationList.vue';
import ChatMessageList from './ChatMessageList.vue';
/** AI 聊天对话 列表 */
export default /*@__PURE__*/_defineComponent({
  ...{
    name: 'AiChatManager'
  },
  __name: 'index',
  setup(__props) {
    return (_ctx, _cache) => {
      const _component_doc_alert = _resolveComponent("doc-alert");
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_el_tabs = _resolveComponent("el-tabs");
      const _component_ContentWrap = _resolveComponent("ContentWrap");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_doc_alert, {
        title: "AI 对话聊天",
        url: "https://doc.iocoder.cn/ai/chat/"
      }), _createVNode(_component_ContentWrap, null, {
        default: _withCtx(() => [_createVNode(_component_el_tabs, null, {
          default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
            label: "对话列表"
          }, {
            default: _withCtx(() => [_createVNode(ChatConversationList)]),
            _: 1
          }), _createVNode(_component_el_tab_pane, {
            label: "消息列表"
          }, {
            default: _withCtx(() => [_createVNode(ChatMessageList)]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      })], 64);
    };
  }
});